/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import ImageFieldItemEdit from "./edit-item";

const ImageFieldEdit = () => {

    return (
        <FieldListEditWrapper>
            <ImageFieldItemEdit />
        </FieldListEditWrapper>
    );
};
ImageFieldEdit.displayName = "ImageFieldEdit";
export { ImageFieldEdit };
